// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-menu-vertical-demo[data-v-2beef02f]:not(.el-menu--collapse) {\n  border: none;\n}\n.submenu[data-v-2beef02f] {\n  float: right;\n}\n.buttonimg[data-v-2beef02f] {\n  height: 60px;\n  background-color: transparent;\n  border: none;\n}\n.showimg[data-v-2beef02f] {\n  width: 26px;\n  height: 26px;\n  position: absolute;\n  top: 17px;\n  left: 17px;\n}\n.showimg[data-v-2beef02f]:active {\n  border: none;\n}\n", ""]);
// Exports
module.exports = exports;
